export default __webpack_public_path__ + "media/img/secondary_white-ec877c742ce16eec5a524384251e7a91.svg";